module.exports = "/assets/data/a4d8f7319f046a1de6886e9b880aa062-GU24.data.json";